import { RewardFeeder } from "@airdao/bond-periphery/core/contracts/types";
import { Contracts, ContractNames } from "@airdao/bond-periphery/core";
import { AddressLike, ZeroAddress } from "ethers";
import { RewardParams } from "./admin";

export async function GetReward(contracts: Contracts, contractName: ContractNames = ContractNames.DiscountFeeder, token: AddressLike, user: AddressLike): Promise<bigint> {
  const feeder = contracts.getContractByName(contractName) as unknown as RewardFeeder;
  return await feeder.getRewardAmount(user, token);
}

export async function GetRewardParams(contracts: Contracts, contractName: ContractNames = ContractNames.DiscountFeeder, token: AddressLike, user: AddressLike): Promise<RewardParams> {
  const feeder = contracts.getContractByName(contractName) as unknown as RewardFeeder;
  const result = await feeder.getRewardParams(user, token);
  return {
    rewardAPY: result.rewardAPY,
    tierMultiplier: result.tierMultiplier,
  };
}

export const GetterMethods = {
  GetReward,
  GetRewardParams,
};

export default GetterMethods;